import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations'; // Import NoopAnimationsModule

import { CommonModule,DatePipe,HashLocationStrategy,LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

///////////////////
import { APP_INITIALIZER } from '@angular/core';
import { KeycloakService } from './core/services/auth/keycloak.service';
import { TokenInterceptor } from './core/services/auth/token.interceptor';
export function kcFactory(keycloakService: KeycloakService): () => void {
  return () => keycloakService.init();
}
////////////////

import { NgxPermissionsModule } from 'ngx-permissions';

import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { ParametrageModule } from './parametrage/parametrage.module';
import { AccountModule } from './account/account.module';
import { MonPortefeuilleModule } from './mon-portefeuille/mon-portefeuille.module';
import { SuiviPortefeuilleModule } from './suivi-portefeuille/suivi-portefeuille.module';
import { FondsPropresModule } from './fonds-propres/fonds-propres.module';
import { NewDashboardModule } from './new-dashboard/new-dashboard.module';

import { LOCALE_ID } from '@angular/core';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { CorporateModule } from './corporate/corporate.module';
import { ParticulierModule } from './particulier/particulier.module';
import { ProfessionnelModule } from './professionnel/professionnel.module';
import { ReportingModule } from './reporting/reporting.module';
import { ToastrModule } from 'ngx-toastr';
import { MonacoEditorModule } from 'ngx-monaco-editor';

registerLocaleData(localeFr);


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    //NoopAnimationsModule,
    AppRoutingModule,
    
    SharedModule,
    CoreModule,

    NewDashboardModule,
    DashboardModule,
    MonPortefeuilleModule,
    ParametrageModule,
    CorporateModule,
    ParticulierModule,
    ProfessionnelModule,
    SuiviPortefeuilleModule,
    AccountModule,
    FondsPropresModule,
    ReportingModule,
    NgxPermissionsModule.forRoot({configurationIsolate: false}),
    ToastrModule.forRoot({
      timeOut: 8000,
      positionClass: 'toast-bottom-right',
      progressBar:true, 
      closeButton:true,
      newestOnTop: true,
      tapToDismiss: true
    }),
    MonacoEditorModule.forRoot()
  ],
  providers: [
    DatePipe,
    {provide:LocationStrategy, useClass:HashLocationStrategy},
    {provide:LOCALE_ID,useValue:"fr-FR"},

    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: kcFactory,
      deps: [KeycloakService],
      multi: true
    },
    {provide : HTTP_INTERCEPTORS, useClass : TokenInterceptor, multi:true}

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
